import { render, staticRenderFns } from "./QualityCourseCreate.vue?vue&type=template&id=394fb2fa&scoped=true&"
import script from "./qualityCouresCreate.js?vue&type=script&lang=js&"
export * from "./qualityCouresCreate.js?vue&type=script&lang=js&"
import style0 from "./QualityCourseCreate.vue?vue&type=style&index=0&id=394fb2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394fb2fa",
  null
  
)

export default component.exports